"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
/* eslint-disable object-shorthand */
var _ = require('lodash');
var _require = require('bson'),
  ObjectId = _require.ObjectId;
module.exports = /*@ngInject*/function ($q, $scope, $location, $document, $uibModal, ProgramService, ChecklistService, PartyService, PartyToPeopleService, PartyToLocationService, RoutingGroupService, LocationService) {
  var ctrl = this;
  ctrl.stack = [];
  ctrl.programLoading = false;
  ctrl.init = function () {
    ctrl.initFirst = true;
  };
  ctrl.setProgram = function (program) {
    ctrl.programLoading = true;
    ProgramService.get({
      id: program._id
    }).$promise.then(function (p) {
      ctrl.program = p;
      return $q.all([ChecklistService.query({
        program: p._id
      }).$promise, PartyService.getPartiesByProgram({
        program: p._id
      }).$promise, RoutingGroupService.getRoutingGroupByProgram({
        programId: p._id
      }).$promise, LocationService.query({
        campusCode: p.campusCode
      }).$promise]);
    }).then(function (results) {
      var _results = (0, _slicedToArray2["default"])(results, 4),
        checklists = _results[0],
        parties = _results[1],
        routingGroups = _results[2],
        locations = _results[3];
      // eslint-disable-next-line prefer-destructuring
      ctrl.checklists = checklists;
      ctrl.parties = parties;
      ctrl.routingGroups = routingGroups;
      ctrl.locations = locations.concat({
        rank: 1,
        _id: '',
        name: '---Select---',
        noSelection: true
      });
      ctrl.programLoading = false;
    });
  };
  ctrl.setAction = function (action, data) {
    if (action === 'NEW_CONFIGURATION' || action === 'EDIT_CONFIGURATION' || action === 'DELETE_CONFIGURATION') {
      ctrl.action = action;
      // eslint-disable-next-line no-undef
      ctrl.configuration = angular.copy(data);
      ctrl.checklist = _.find(ctrl.checklists, function (o) {
        return o._id === ctrl.configuration.checklist;
      });
      ctrl.party = _.find(ctrl.parties, function (o) {
        return o._id === ctrl.configuration.party;
      });
      ctrl.routingGroup = _.find(ctrl.routingGroups, function (o) {
        return o._id === ctrl.configuration.routingGroup;
      });
      ctrl.location = _.find(ctrl.locations, function (o) {
        return o._id === ctrl.configuration.location;
      });
    } else if (action === 'NEW_CHECKLIST') {
      ctrl.stack.push(ctrl.action);
      ctrl.action = action;
      ctrl.modal = $uibModal.open({
        templateUrl: 'management/configuration/_checklist-form.html',
        // eslint-disable-next-line no-undef
        appendTo: angular.element(document.querySelector('#management-configuration-page')),
        // eslint-disable-next-line func-names
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.checklist = data;
          $ctrl.isParent = ctrl.program.campusCode < 0;
          ChecklistService.fetchShared().$promise.then(function (checklists) {
            $ctrl.parentChecklists = checklists;
          });
          $ctrl.updateFindingsType = function (parentId) {
            $ctrl.checklist.findingsType = parentId ? $ctrl.parentChecklists.find(function (checklist) {
              return checklist._id === parentId;
            }).findingsType : null;
          };

          // eslint-disable-next-line func-names
          $ctrl.validate = function (field) {
            $ctrl['checklist-form'][field].$error.duplicate = _.some(ctrl.checklists, function (checklist) {
              return _.toLower(checklist.name) === _.toLower($ctrl.checklist.name);
            });
            $ctrl['checklist-form'][field].$setValidity('duplicate', !$ctrl['checklist-form'][field].$error.duplicate, $ctrl['checklist-form'][field]);
          };

          // eslint-disable-next-line func-names
          $ctrl.submit = function () {
            ctrl.checklist = $ctrl.checklist;
            if (ctrl.checklist.parentChecklist) {
              ctrl.checklist.name = "".concat(ctrl.checklist.name, " from shared checklist ").concat($ctrl.parentChecklists.find(function (checklist) {
                return checklist._id === ctrl.checklist.parentChecklist;
              }).name);
            }
            ctrl.submit();
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            ctrl.setAction(null, null);
          };
        },
        controllerAs: '$ctrl',
        backdrop: 'static'
      });
    } else if (action === 'NEW_PARTY') {
      ctrl.stack.push(ctrl.action);
      ctrl.action = action;
      ctrl.modal = $uibModal.open({
        templateUrl: 'management/configuration/_party-form.html',
        // eslint-disable-next-line no-undef
        appendTo: angular.element(document.querySelector('#management-configuration-page')),
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.party = data;
          PartyService.getAllPartyTypes().$promise.then(function (types) {
            $ctrl.partyList = types;
          })["catch"](function () {
            $ctrl.partyList = [];
          });
          $ctrl.submit = function (form) {
            ctrl.party = $ctrl.party;
            ctrl.submit(form);
          };
          $ctrl.validate = function (field) {
            $ctrl['party-form'][field].$error.duplicate = _.some(ctrl.parties, function (party) {
              return _.toLower(party.name) === _.toLower($ctrl.party.name);
            });
            $ctrl['party-form'].$setValidity('duplicate', !$ctrl['party-form'][field].$error.duplicate, $ctrl['party-form'][field]);
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            ctrl.setAction(null, null);
          };
        },
        controllerAs: '$ctrl',
        backdrop: 'static'
      });
    } else if (action === 'NEW_ROUTING_GROUP') {
      ctrl.stack.push(ctrl.action);
      ctrl.action = action;
      ctrl.modal = $uibModal.open({
        templateUrl: 'management/configuration/_routing-group-form.html',
        // eslint-disable-next-line no-undef
        appendTo: angular.element(document.querySelector('#management-configuration-page')),
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.routingGroup = data;
          $ctrl.submit = function (form) {
            ctrl.routingGroup = $ctrl.routingGroup;
            ctrl.submit(form);
          };
          $ctrl.validate = function (field) {
            $ctrl['routing-group-form'][field].$error.duplicate = _.some(ctrl.routingGroups, function (routingGroup) {
              return _.toLower(routingGroup.name) === _.toLower($ctrl.routingGroup.name);
            });
            $ctrl['routing-group-form'].$setValidity('duplicate', !$ctrl['routing-group-form'][field].$error.duplicate, $ctrl['routing-group-form'][field]);
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            ctrl.setAction(null, null);
          };
        },
        controllerAs: '$ctrl',
        backdrop: 'static'
      });
    } else if (action === 'NEW_LOCATION') {
      ctrl.stack.push(ctrl.action);
      ctrl.action = action;
      ctrl.modal = $uibModal.open({
        templateUrl: 'management/configuration/_location-form.html',
        // eslint-disable-next-line no-undef
        appendTo: angular.element(document.querySelector('#management-configuration-page')),
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.location = data;
          $ctrl.submit = function (form) {
            ctrl.location = $ctrl.location;
            ctrl.submit(form);
          };
          $ctrl.validate = function (field) {
            $ctrl['location-form'][field].$error.duplicate = _.some(ctrl.locations, function (location) {
              return _.toLower(location.name) === _.toLower($ctrl.location.name);
            });
            $ctrl['location-form'].$setValidity('duplicate', !$ctrl['location-form'][field].$error.duplicate, $ctrl['location-form'][field]);
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            ctrl.setAction(null, null);
          };
        },
        controllerAs: '$ctrl',
        backdrop: 'static'
      });
    } else {
      if (ctrl.action === 'NEW_CONFIGURATION' || ctrl.action === 'EDIT_CONFIGURATION' || ctrl.action === 'DELETE_CONFIGURATION') {
        ctrl.configuration = data;
      } else if (ctrl.action === 'NEW_CHECKLIST' || ctrl.action === 'NEW_PARTY' || ctrl.action === 'NEW_ROUTING_GROUP' || ctrl.action === 'NEW_LOCATION') {
        ctrl.modal.close({});
      }
      ctrl.action = ctrl.stack.pop();
    }
  };
  ctrl.setConfigurationChecklist = function (checklist) {
    ctrl.configuration.checklist = checklist._id.toString();
  };
  ctrl.setConfigurationParty = function (party) {
    ctrl.configuration.party = party._id.toString();
    $q.all([PartyToPeopleService.get({
      'source.id': ctrl.configuration.party
    }).$promise, PartyToLocationService.get({
      'source.id': ctrl.configuration.party
    }).$promise]).then(function (results) {
      var _results2 = (0, _slicedToArray2["default"])(results, 2),
        partyToPeople = _results2[0],
        partyToLocation = _results2[1];
      ctrl.configuration.partyToPeople = partyToPeople._id;
      ctrl.configuration.partyToLocation = partyToLocation._id;
    })["catch"]();
  };
  ctrl.setConfigurationRoutingGroup = function (routingGroup) {
    ctrl.configuration.routingGroup = routingGroup._id;
  };
  ctrl.validate = function (field) {
    ctrl['configuration-form'][field].$error.duplicate = _.some(ctrl.program.configurations, function (configuration) {
      return _.toLower(ctrl.configuration.name) === _.toLower(configuration.name);
    });
    ctrl['configuration-form'].$setValidity('duplicate', !ctrl['configuration-form'][field].$error.duplicate, ctrl['configuration-form'][field]);
  };
  ctrl.clearVerificationDefaultValue = function () {
    ctrl.configuration.verificationDefaultValue = false;
  };
  ctrl.submit = function () {
    if (ctrl.action === 'EDIT_CONFIGURATION') {
      ctrl.configuration.overdueNotificationDays = ctrl.configuration.overdueNotificationDays ? _.sortedUniq(_.orderBy(ctrl.configuration.overdueNotificationDays.map(function (overdueNotificationDay) {
        return (
          // eslint-disable-next-line radix
          parseInt(overdueNotificationDay)
        );
      }))) : [];
      var oldRoutingGroup = _.find(ctrl.routingGroups, {
        _id: ctrl.configuration.routingGroup
      });
      var newRoutingGroup = _.find(ctrl.routingGroups, {
        _id: ctrl.routingGroup._id.toString()
      });
      if (!oldRoutingGroup || oldRoutingGroup._id !== newRoutingGroup._id) {
        if (oldRoutingGroup) {
          // remove configuration id from old routing group
          oldRoutingGroup.configurations = _.without(oldRoutingGroup.configurations, ctrl.configuration._id);
          RoutingGroupService.update({
            id: oldRoutingGroup._id
          }, oldRoutingGroup);
        }

        // add configuration id to selected routing group
        newRoutingGroup.configurations = _.concat(newRoutingGroup.configurations, ctrl.configuration._id);
        RoutingGroupService.update({
          id: newRoutingGroup._id
        }, newRoutingGroup);
        ctrl.configuration.routingGroup = newRoutingGroup._id;
      }
      ctrl.configuration.party = ctrl.party._id.toString();
      ctrl.configuration.location = ctrl.location && !ctrl.location.noSelection ? ctrl.location._id : null;

      // allow partyToLocation or location but not both
      $q.all([PartyToPeopleService.get({
        'source.id': ctrl.configuration.party
      }).$promise, !ctrl.location || ctrl.location.noSelection || !!ctrl.party.sync ? PartyToLocationService.get({
        'source.id': ctrl.configuration.party
      }).$promise : $q.resolve({})]).then(function (results) {
        ctrl.configuration.partyToPeople = results[0]._id || null;
        ctrl.configuration.partyToLocation = results[1]._id || null;
        if (ctrl.configuration.location) {
          ctrl.configuration.partyToLocation = null;
        }
        return ProgramService.updateConfiguration({
          id: ctrl.program._id,
          configurationId: ctrl.configuration._id
        }, ctrl.configuration).$promise;
      }).then(function () {
        ctrl.setAction(null, null);
        ctrl.setProgram(ctrl.program);
      });
    } else if (ctrl.action === 'NEW_CONFIGURATION') {
      ctrl.programLoading = true;
      ctrl.configuration._id = new ObjectId();
      ctrl.configuration.program = ctrl.program._id;
      ctrl.configuration.hasReview = !!ctrl.configuration.hasReview;
      ctrl.configuration.mergeReport = !!ctrl.configuration.mergeReport;
      ctrl.configuration.sendEmail = !!ctrl.configuration.sendEmail;
      ctrl.configuration.sendDoneEmail = !!ctrl.configuration.sendDoneEmail;
      ctrl.configuration.ccInspectors = !!ctrl.configuration.ccInspectors;
      ctrl.configuration.categoriesCollapsed = !!ctrl.configuration.categoriesCollapsed;
      ctrl.configuration.updatePartyPeople = !!ctrl.configuration.updatePartyPeople;
      ctrl.configuration.shareableLink = !!ctrl.configuration.shareableLink;
      ctrl.configuration.managerInspection = !!ctrl.configuration.managerInspection;
      ctrl.configuration.ticketingSystem = !!ctrl.configuration.ticketingSystem;
      ctrl.configuration.party = ctrl.party._id.toString();
      ctrl.configuration.routingGroup = ctrl.routingGroup._id;
      ctrl.configuration.location = ctrl.location && !ctrl.location.noSelection && !ctrl.party.sync ? ctrl.location._id : null;
      ctrl.configuration.reminderNotificationDays = ctrl.configuration.reminderNotificationDays ? ctrl.configuration.reminderNotificationDays : null;
      ctrl.configuration.overdueNotificationDays = ctrl.configuration.overdueNotificationDays ? _.sortedUniq(_.orderBy(ctrl.configuration.overdueNotificationDays.map(function (overdueNotificationDay) {
        return (
          // eslint-disable-next-line radix
          parseInt(overdueNotificationDay)
        );
      }))) : [];
      ctrl.configuration.hasVerification = !!ctrl.configuration.hasVerification;
      ctrl.configuration.verificationDefaultValue = !!ctrl.configuration.verificationDefaultValue;
      ctrl.configuration.active = true;

      // allow partyToLocation or location but not both
      $q.all([PartyToPeopleService.get({
        'source.id': ctrl.configuration.party
      }).$promise, !ctrl.location || ctrl.location.noSelection || !!ctrl.party.sync ? PartyToLocationService.get({
        'source.id': ctrl.configuration.party
      }).$promise : $q.resolve({})]).then(function (results) {
        ctrl.configuration.partyToPeople = results[0]._id || null;
        ctrl.configuration.partyToLocation = results[1]._id || null;
        if (ctrl.configuration.location) {
          ctrl.configuration.partyToLocation = null;
        }
        return ProgramService.createConfiguration({
          id: ctrl.program._id
        }, ctrl.configuration).$promise;
      }).then(function () {
        var routingGroup = _.find(ctrl.routingGroups, {
          _id: ctrl.configuration.routingGroup.toString()
        });
        routingGroup.configurations = _.concat(routingGroup.configurations, ctrl.configuration._id);
        return RoutingGroupService.update({
          id: ctrl.configuration.routingGroup
        }, routingGroup).$promise;
      }).then(function () {
        ctrl.setAction(null, null);
        ctrl.setProgram(ctrl.program);
        ctrl.programLoading = false;
      });
    } else if (ctrl.action === 'DELETE_CONFIGURATION') {
      ProgramService.deleteConfiguration({
        id: ctrl.program._id,
        configurationId: ctrl.configuration._id
      }).$promise.then(function () {
        ctrl.setAction(null, null);
        ctrl.setProgram(ctrl.program);
      });
    } else if (ctrl.action === 'NEW_CHECKLIST') {
      var isShared = ctrl.program.campusCode < 0;
      ctrl.checklist._id = new ObjectId();
      ctrl.checklist.program = ctrl.program._id;
      ctrl.checklist.type = isShared ? 'SHARED' : 'PRIVATE';
      ctrl.checklist.showActionPlan = !!ctrl.checklist.showActionPlan;
      ChecklistService.save({
        checklist: ctrl.checklist
      }).$promise.then(function () {
        ctrl.setConfigurationChecklist(ctrl.checklist);
        return ChecklistService.query({
          program: ctrl.program._id
        }).$promise;
      }).then(function (result) {
        ctrl.setAction(null, null);
        ctrl.checklists = result;
      });
    } else if (ctrl.action === 'NEW_PARTY') {
      ctrl.party._id = new ObjectId();
      ctrl.party.campus = ctrl.program.campusCode;
      ctrl.party.program = ctrl.program._id;
      ctrl.party["public"] = true;
      ctrl.party.sync = !!ctrl.party.sync;
      ctrl.party.syncWithCoreServices = !!ctrl.party.syncWithCoreServices;
      ctrl.party.attributes = [];
      ctrl.party.members = [];
      PartyService.save(ctrl.party).$promise.then(function () {
        var p2p = {
          _id: new ObjectId(),
          name: "".concat(ctrl.party.name, " To People Mapping"),
          source: {
            id: ctrl.party._id,
            name: ctrl.party.name
          },
          program: ctrl.program._id,
          mappings: []
        };
        var p2l = {
          _id: new ObjectId(),
          name: "".concat(ctrl.party.name, " To Location Mapping"),
          source: {
            id: ctrl.party._id,
            name: ctrl.party.name
          },
          program: ctrl.program._id,
          mappings: []
        };
        return $q.all([PartyToPeopleService.save(p2p).$promise, PartyToLocationService.save(p2l).$promise]);
      }).then(function () {
        ctrl.setConfigurationParty(ctrl.party);
        return PartyService.getPartiesByProgram({
          program: ctrl.program._id
        }).$promise;
      }).then(function (result) {
        ctrl.setAction(null, null);
        ctrl.parties = result;
      });
    } else if (ctrl.action === 'NEW_ROUTING_GROUP') {
      ctrl.routingGroup._id = new ObjectId();
      ctrl.routingGroup.program = ctrl.program._id;
      ctrl.routingGroup.configurations = [];
      ctrl.routingGroup.groups = [];
      RoutingGroupService.save(ctrl.routingGroup).$promise.then(function () {
        return RoutingGroupService.getRoutingGroupByProgram({
          programId: ctrl.program._id
        }).$promise;
      }).then(function (result) {
        ctrl.setAction(null, null);
        ctrl.setConfigurationRoutingGroup(ctrl.routingGroup);
        ctrl.routingGroups = result;
      });
    } else if (ctrl.action === 'NEW_LOCATION') {
      ctrl.location._id = new ObjectId();
      ctrl.location.program = ctrl.program._id;
      ctrl.location.campus = ctrl.program.campusCode;
      ctrl.location["public"] = true;
      ctrl.location.type = 'ROOM';
      ctrl.location.members = [];
      ctrl.location.sourceKeys = [];
      LocationService.save(ctrl.location).$promise.then(function () {
        return LocationService.query({
          program: ctrl.program._id
        }).$promise;
      }).then(function (result) {
        ctrl.setAction(null, null);
        ctrl.configuration.location = ctrl.location._id;
        ctrl.locations = result;
      });
    }
  };
  $scope.$watch(function () {
    return $location.search();
  }, function (newSearch, oldSearch) {
    if (newSearch.program !== oldSearch.program || ctrl.initFirst) {
      ctrl.initFirst = false;
      ctrl.setProgram({
        _id: $location.search().program
      });
      ctrl.action = null;
      ctrl.configuration = null;
      ctrl.checklist = null;
      ctrl.party = null;
      ctrl.routingGroup = null;
      ctrl.location = null;
    }
  }, true);
  ctrl.init();
};